module.exports = __webpack_public_path__ + "media/images/flags/dj-5e87c43a2217d43fd88b945a3f945c8a.svg";